import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { useSelectedBusiness } from '../../redux/store';
import { UserContext } from '../auth/auth-context';
import { useContext } from 'react'; 
import { CREATE_BUSINESS_PROFILE } from '../../util/constants';
 
export function WalletMenuItem() {

    const { providerUser } = useContext(UserContext);
    const selectedBusiness = useSelectedBusiness();

    // Compute the wallet URL if they have a business
    const walletUrl = selectedBusiness
        ? `/${selectedBusiness.businessBasic.url}/${providerUser.url}/wallet`
        : undefined;

    return (
        <Tooltip
            title={providerUser.defaultBusinessId ? "" : CREATE_BUSINESS_PROFILE}
            placement="right"
            arrow
        >
            {/* span needed so Tooltip works on disabled child */}
            <span>
                <MenuItem
                    component={selectedBusiness ? RouterLink : 'div'}
                    to={walletUrl}
                    disabled={!providerUser.defaultBusinessId}
                    sx={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        cursor: selectedBusiness ? "pointer" : "not-allowed",
                        maxWidth: { xs: '100%', sm: '200px' }, // responsive width
                        whiteSpace: 'normal', // allow wrapping
                        lineHeight: 1.3,
                    }}
                >
                    <ListItemText
                        primary="🪙 PlanyCoin Wallet"
                        sx={{
                            textAlign: "left",
                            wordWrap: 'break-word', // wrap long text
                            whiteSpace: 'normal',  // allow multiple lines
                            fontSize: '0.9rem',
                        }}
                    />
                </MenuItem>
            </span>
        </Tooltip>
    );
}
